import React from 'react';
import MeasureSelectionPopup from '../measure-selection-popup/MeasureSelectionPopup';
import { getRawForms, getGroupedForms } from '../../../common/utils/prepareFormsData';
import { useAppContext } from '../../../common/contexts/AppContext';
import { usePopupContext } from '../../../common/contexts/PopupContext';

const PMFormSelectionPopup = () => {
    const {
        params: { skillName, measureName, grade, studentId, initialFormUidsByGrade },
        actions: { hidePMFormSelectionPopup },
    } = usePopupContext();
    const { forms } = useAppContext();
    const rawForms = getRawForms(forms);
    const formsBySkill = getGroupedForms(rawForms, skillName, measureName);
    return (
        <MeasureSelectionPopup
            skillName={skillName}
            measureName={measureName}
            formsBySkill={formsBySkill}
            grade={grade}
            onClose={hidePMFormSelectionPopup}
            studentId={studentId}
            initialFormUidsByGrade={initialFormUidsByGrade}
            isPopupOpened
            isScrollLockEnabled
        />
    );
};

export default PMFormSelectionPopup;
